import { Flex } from "antd";
import { FC } from "react";
import { TaskStartVisit } from "tm-shared/types";

import { PrimaryText } from "@/components/Typography/Styled";
import { CoordinatesLink } from "@/components/UI/CoordinatesLink";

import { InfoRowList } from "../components/InfoRowList";
import { TaskViewModal } from "../TaskViewModal";

interface StartVisitViewModalProps {
    task: TaskStartVisit;
    onClose: () => void;
}

export const StartVisitViewModal: FC<StartVisitViewModalProps> = ({
    task,
    onClose,
}) => {
    const taskPayload = task.payload;
    const completedAt = task?.completedAt;

    if (!taskPayload || !completedAt) return null;

    const { coords } = taskPayload;

    const hasCoords = !!coords;

    const infoRows = [
        {
            label: "Координати:",
            value: hasCoords ? (
                <CoordinatesLink {...coords} />
            ) : (
                <PrimaryText>Не вдалося визначити</PrimaryText>
            ),
        },
        {
            label: "Точність:",
            value: hasCoords ? `${coords.accuracy.toFixed(0)} м.` : "—",
        },
    ];

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                <InfoRowList items={infoRows} />
            </Flex>
        </TaskViewModal>
    );
};
